import { MenuItem } from "@mui/material";

export const generatePeopleNumberOpts = (from: number, to: number) => {
  const options = [];

  for (let i = from; i <= to; i++) {
    const option = `${i}名`;
    options.push(
      <MenuItem key={option} value={i}>
        {option}
      </MenuItem>
    );
  }
  return options;
};
